import './App.css';
import Header from './Header';
import HeroSection from './HeroSection';
import HomeSlider from './HomeSlider';
import AboutSection from './AboutSection';
import FeaturedProducts from './FeaturedProducts';
import WhyChooseSection from './WhyChooseSection';
import NewsletterSection from './NewsletterSection';
import Footer from './Footer';
import AboutPage from './AboutPage';
import BecomeDistributorPage from './BecomeDistributorPage';
import FindDealerPage from './FindDealerPage';
import ThreePlyReflectivePage from './ThreePlyReflectivePage';
import DyedReflectivePage from './DyedReflectivePage';
import SignatureSputteringPage from './SignatureSputteringPage';
import TwoPlyReflectivePage from './TwoPlyReflectivePage';
import ContactPage from './ContactPage';
import FAQsPage from './FAQsPage';
import AutoStorePage from './AutoStorePage';
import CartPage from './CartPage';
import CheckoutPage from './CheckoutPage';
import ThankYouPage from './ThankYouPage';
import DecorativeFilmsPage from './DecorativeFilmsPage';
import SafetySecurityFilmsPage from './SafetySecurityFilmsPage';
import SkinEyeCarePage from './SkinEyeCarePage';
import NanoCeramicPage from './NanoCeramicPage';
import PlatinumSignaturePage from './PlatinumSignaturePage';
import ReflectiveFilmPage from './ReflectiveFilmPage';
import WindshieldProtectionPage from './WindshieldProtectionPage';
import PreCutFilmsPage from './PreCutFilmsPage';
import ArchitecturalPage from './ArchitecturalPage';
import AutomotivePage from './AutomotivePage';
import WhyDermaProtecPage from './WhyDermaProtecPage';
import { CartProvider } from './CartContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AdminLoginPage from './AdminLoginPage';
import AdminDashboardPage from './AdminDashboardPage';

function Home() {
  return (
    <>
      <Header />
      <HomeSlider />
      <section className="home-hero-content">
        <div className="home-hero-content-inner">
          <h2>Drive Smarter. Ride Cooler.</h2>
          <p>Whether you're commuting under the desert sun or parked for hours, Derma Protec's Films keep your vehicle cooler, your interiors protected, and your driving experience elevated.</p>
          <Link to="/why-derma-protec" className="home-hero-btn">Why Derma Protec</Link>
        </div>
      </section>
      <AboutSection />
      <FeaturedProducts />
      <WhyChooseSection />
      <NewsletterSection />
      <Footer />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<><Header /><AboutPage /><Footer /></>} />
          <Route path="/why-derma-protec" element={<><Header /><WhyDermaProtecPage /><Footer /></>} />
          <Route path="/become-distributor" element={<><Header /><BecomeDistributorPage /><Footer /></>} />
          <Route path="/find-dealer" element={<><Header /><FindDealerPage /><Footer /></>} />
          <Route path="/3-ply-reflective" element={<><Header /><ThreePlyReflectivePage /><Footer /></>} />
          <Route path="/dyed-reflective" element={<><Header /><DyedReflectivePage /><Footer /></>} />
          <Route path="/signature-sputtering" element={<><Header /><SignatureSputteringPage /><Footer /></>} />
          <Route path="/2-ply-reflective" element={<><Header /><TwoPlyReflectivePage /><Footer /></>} />
          <Route path="/decorative-films" element={<><Header /><DecorativeFilmsPage /><Footer /></>} />
          <Route path="/safety-security-films" element={<><Header /><SafetySecurityFilmsPage /><Footer /></>} />
          <Route path="/contact" element={<><Header /><ContactPage /><Footer /></>} />
          <Route path="/faqs" element={<><Header /><FAQsPage /><Footer /></>} />
          <Route path="/auto-store" element={<><Header /><AutoStorePage /><Footer /></>} />
          <Route path="/cart" element={<><Header /><CartPage /><Footer /></>} />
          <Route path="/checkout" element={<><Header /><CheckoutPage /><Footer /></>} />
          <Route path="/thank-you" element={<><Header /><ThankYouPage /><Footer /></>} />
          <Route path="/skin-eye-care" element={<><Header /><SkinEyeCarePage /><Footer /></>} />
          <Route path="/nano-ceramic" element={<><Header /><NanoCeramicPage /><Footer /></>} />
          <Route path="/platinum-signature" element={<><Header /><PlatinumSignaturePage /><Footer /></>} />
          <Route path="/reflective-film" element={<><Header /><ReflectiveFilmPage /><Footer /></>} />
          <Route path="/windshield-protection" element={<><Header /><WindshieldProtectionPage /><Footer /></>} />
          <Route path="/pre-cut-films" element={<><Header /><PreCutFilmsPage /><Footer /></>} />
          <Route path="/architectural" element={<><Header /><ArchitecturalPage /><Footer /></>} />
          <Route path="/automotive" element={<><Header /><AutomotivePage /><Footer /></>} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin-dashboard" element={<AdminDashboardPage />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
